// extracted by extract-css-chunks-webpack-plugin
module.exports = {"calculator":"H5hphu","modal":"_2vOml8","open":"_2p_Tf3"};